import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { BrandPortalPage } from './pages/BrandPortalPage';
import { HomePage } from './pages/HomePage';
import { InvestorPage } from './pages/InvestorPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/brand" element={<BrandPortalPage data-id="element-5" />} data-id="element-4" />
        <Route path="/investor" element={<InvestorPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}